// ======================================================================
// File Name       : SelectedUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Table, Button, Form } from 'react-bootstrap';


class SelectedUserList extends Component {

  render() {
    const { addedUserList } = this.props;
    const userList = Object.keys(addedUserList);

    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-top-10 padding-left-right-clear">
          対象ユーザー
        </Col>
        <Col sm={10} className="text-right padding-left-right-clear margin-bottom-5">
          <Button variant="default" onClick={this.props.handleRemoveAll}>ユーザー一括削除</Button>
        </Col>

        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th>ユーザー名</th>
              <th>ログインID</th>
              <th>グループ名</th>
              <th width="70">操作</th>
            </tr>
          </thead>
          <tbody>
            {
              userList &&
              userList.map((userSecernId, index) => {
                const user = addedUserList[userSecernId];
                return (
                  <tr key={index} className={user.addNew ? 'background_new_record' : ''}>
                    <td>{user.userName}</td>
                    <td>{user.loginId}</td>
                    <td>{user.groupName}</td>
                    <td className="text-center">
                      <i
                        role="button"
                        className="bi bi-trash"
                        onClick={this.props.handleRemoveUser.bind(this, userSecernId)}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>

        <Form.Group className="margin-top-20 text-center col-sm-12">
          <Button
            variant="default"
            className="btn-96 margin-right-10"
            onClick={this.props.onCancel}
          >
            キャンセル
          </Button>
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.props.onOK}
          >
            OK
          </Button>
        </Form.Group>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { addedUserList } = state.csvDownload;
  return { addedUserList };
};
export default connect(mapStateToProps)(SelectedUserList);

